export enum ShippingOption {
  Home = 'home',
  Self = 'self',
}

export const RANDOM_ADDRESS_RADIUS = 5_000;
export const TAX_FEE = 0.2;
export const DEFAULT_STATUS_UPDATE_INTERVAL_SECONDS = 60;
export const DEFAULT_TASK_CREATE_INTERVAL_SECONDS = 45;
export const DEFAULT_NUMBER_OF_TASKS_ECOMERCE_DEMO = 10;
export const DEFAULT_NUMBER_OF_TASKS_INTERNAL_DRIVER_DEMO = 4;
